module.exports = __webpack_public_path__ + "img/icon-anti-virus.58ee840a.svg";